import { route } from "@circle-react/lib/routes/define";

export const adminDashboardRoutes = {
  index: route("/settings/dashboard", {
    title: "Dashboard",
    requires: "admin",
    description:
      "Admin home dashboard. High-level overview of recent community activity, member growth, website traffic, and quick links into the rest of the settings area.",
  }),
};
